import { getMyAbilities } from '../services/rbacService';

export const pathToPermissionKey = (path) => {
  if (!path || path === '/' || path === '') return 'dashboard.view';
  const clean = path.replace(/^\//, '').replace(/\/$/, '');
  if (!clean) return 'dashboard.view';
  return clean.replaceAll('/', '.') + '.view';
};

let cachedAbilities = null;
let abilitiesInflight = null;

/** Başarısız/boş sonucu kalıcı cache’leme — restart sonrası menü/sayfa kilitlenmesin */
export const clearAbilitiesCache = () => {
  cachedAbilities = null;
  abilitiesInflight = null;
};

export const loadAbilities = async ({ force = false } = {}) => {
  if (!force && cachedAbilities && Object.keys(cachedAbilities).length > 0) {
    return cachedAbilities;
  }
  if (!force && abilitiesInflight) return abilitiesInflight;

  abilitiesInflight = (async () => {
    try {
      const next = await getMyAbilities();
      if (next && typeof next === 'object' && Object.keys(next).length > 0) {
        cachedAbilities = next;
        return cachedAbilities;
      }
      return next && typeof next === 'object' ? next : {};
    } catch (_) {
      return {};
    } finally {
      abilitiesInflight = null;
    }
  })();

  return abilitiesInflight;
};

export const canAccessPath = async (path) => {
  const abilities = await loadAbilities();
  const key = pathToPermissionKey(path);
  return !!abilities[key];
};



